// usePreloadUserNotifications.js
import { useEffect } from 'react';

// Context
import { useUser } from 'context/UserContext';

import { subscribeToUnreadUserNotifications } from 'services/notifications/NotificationService';

/**
 * Keeps the app-wide unread notification feed in sync.
 *
 * Only unread rows are streamed, and only up to a cap, because the sole consumers are
 * badge counts. The full per-base history is loaded on demand by the notifications
 * section instead.
 */
const usePreloadUserNotifications = () => {

  // User Context
  const { isEmailVerified, user, setUserUnreadNotifications } = useUser();

  useEffect(() => {

    // Exit early if no selected user
    if (!user || !user.key || !isEmailVerified) {
      setUserUnreadNotifications([]);
      return;
    }

    return subscribeToUnreadUserNotifications(user.key, (notifications) => {
      setUserUnreadNotifications(notifications);
    });
  }, [isEmailVerified, user, setUserUnreadNotifications]);

};

export default usePreloadUserNotifications;
